import React from 'react';
import useToggle from '../../../../hooks/useToggle';
import { Column, Columns } from '../../../../styled/Columns/wrappers';
import Box from '../../../../styled/Box';
import Distance from '../../../../styled/Distance';
import Text from '../../../../styled/Text';
import { StyledLink } from '../../../../styled/Link';
import { Table, TableRow, TableCell } from '../../../../styled/Table/wrappers';

interface ISpecificationRow extends ISpecification {
  odd: boolean;
}

const SpecificationRow = ({ columns, description, odd }: ISpecificationRow) => {
  const [showDesc, toggleShowDesc] = useToggle(false);

  return (
    <Box background={odd ? 'main' : true} rounded noSpacing>
      <Columns className="space-1">
        {columns.map((column, i) => (
          <Column key={column} className={(i <= 0 && 'grow') || undefined}>
            {(i > 0 || !description) && column}

            {i === 0 && description && (
              <>
                <StyledLink as="button" onClick={toggleShowDesc}>
                  {column}
                </StyledLink>
              </>
            )}
          </Column>
        ))}
      </Columns>
      {showDesc && (
        <>
          <Distance size="1" />
          {description}
        </>
      )}
    </Box>
  );
};

const SpecificationRowThreeCols = ({ columns, description, odd }: ISpecificationRow) => {
  const [showDesc, toggleShowDesc] = useToggle(false);

  return (
    <>
      <TableRow background={!odd}>
        {columns.map((column, i) => (
          <TableCell key={column}>
            {(i > 0 || !description) && column}

            {i === 0 && description && (
              <>
                <StyledLink as="button" onClick={toggleShowDesc}>
                  {column}
                </StyledLink>
              </>
            )}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        {showDesc && (
          <>
            <TableCell colSpan={3}>{description}</TableCell>
          </>
        )}
      </TableRow>
    </>
  );
};

interface IGenericInformation {
  sections: {
    [key: string]: ISpecification[];
  };
}

const GenericInformation = ({ sections }: IGenericInformation) => {
  return (
    <>
      {Object.keys(sections).map((section) => (
        <React.Fragment key={section}>
          {section && (
            <>
              <Text weight="medium">{section}:</Text>
              <Distance size={['2', '3']} />
            </>
          )}
          {sections[section][0].columns.length >= 3 ? (
            <Table cellSpacing={0}>
              <tbody>
                {sections[section].map((row, i) => (
                  <SpecificationRowThreeCols
                    {...row}
                    odd={!!(i % 2)}
                    key={(row.key || '').toString()}
                  />
                ))}
              </tbody>
            </Table>
          ) : (
            sections[section].map((row, i) => (
              <SpecificationRow {...row} key={row.key} odd={!!(i % 2)} />
            ))
          )}
          <Distance line size="4" />
        </React.Fragment>
      ))}
    </>
  );
};

export default GenericInformation;
